<script>
import BaseList from '@/views/base/base-list.vue'
import { FileExtensionType, FileExtention } from '@/common/constant'
import commonFn from '@/common/common-fn'
import upperFirst from 'lodash/upperFirst'
import { newUuid } from '@/utils/uuid'
import Viewer from 'viewerjs/dist/viewer.esm'
import FileAPI from '@/apis/business/common/file-api.js'
// import MsButton from '@/components/button'
// import { defineComponent, createApp } from 'vue'

const PreviewPopup = () => import('./src/popup-preview')

// Control xem trước hay tải xuống 1 định dạng file nào đó
export default {
  name: 'MsPreview',
  inheritAttrs: true,
  extends: BaseList,
  emits: ['previousPage', 'clickPreview'],
  props: {
    // tên file
    fileId: {
      type: String,
      default: null
    },
    // file được lấy trong kho dữ liệu nào
    storageType: {
      type: Number,
      default: null
    },
    // chủ sở hữu của file
    ownerId: {
      type: String,
      default: ''
    },
    // tên file cái này chỉ cần thiết với file muốn tải về còn xem trước thì ko cần
    clientFileName: {
      type: String,
      default: ''
    },
    // Định dạng file muốn xem trước có các dạng cơ bản như png pdf
    fileExtension: {
      type: String,
      default: null
    },
    downloadFileName: {
      type: String,
      default: null
    },
    // Xem trước bằng true, tải xuống thì để về false
    isPreview: {
      type: Boolean,
      default: true
    },
    // độ rộng cần preview với ảnh
    width: {
      type: Number,
      default: null
    },
    // Nếu cái này là true cũng có nghĩa là file tạm
    isTemp: {
      type: Boolean,
      default: false
    },

    /** Có nút back quay lại ko */
    isShowPrevious: {
      type: Boolean,
      default: false
    },
    isShowFileName: {
      type: Boolean,
      default: false
    },
    /** Có bật popup khi bấm vào ảnh hay ko,
     * cái này cần cho các bài tập mà câi trả lời ảnh nó bé quá
     * cập nhật thêm là cả video hay mọi thứ bấm vào đều bật lên nnanh3 09-10-2021 */
    isShowPopupPreview: {
      type: Boolean,
      default: false
    },
    isViewerImage: {
      type: Boolean,
      default: false
    },
    moreInfo: {
      type: String,
      default: null
    },
    isAutoPlay: {
      type: Boolean,
      default: false
    },
    collectionName: {
      type: String,
      default: null
    },
    fieldName: {
      type: String,
      default: null
    },
    modifiedDate: {
      type: Object || String || Number,
      default: null
    }
  },

  data () {
    return {
      viewer: null,
      previousPage: require('./src/icon/swap.svg'),
      PreviewSetup: 'PreviewPopup',
      imgId: '',
      videoMp4: '',
      isAllowPlaying: true, // khi bấm vào video thì có cho phép play ko, vì mong muốn là khi bấm vào video sẽ ko play video nhỏ mà play ở video lớn hơn
      // event onPlaying sẽ xảy ra sau sự kiện click vào container nên đoạn dưới có dùng biến này khi click vào container sẽ ko cho play
      // khi play video sẽ kiểm tra biến đó, kiểm tra xong dù có tnao thì cũng để lại n bằng true cho lần tiếp theo check
      containerId: 'container_' + newUuid(),
      degreeInViewer: 0, // góc xoay ảnh trong viewer
      degreeSaved: 0 // dóc xoay ảnh đã lưu
    }
  },

  computed: {
    attrs () {
      return {
        ...this.$attrs
      }
    },
    url () {
      const props = this.$props
      return commonFn.buildPreviewFileUrl({
        fileId: props.fileId,
        storageType: props.storageType,
        ownerId: props.ownerId,
        clientFileName: props.clientFileName,
        downloadFileName: props.downloadFileName,
        isPreview: props.isPreview,
        width: props.width,
        isTemp: props.isTemp,
        modifiedDate: props.modifiedDate
      })
    },
    isUseEmbedUrl () {
      const me = this
      const storageTypes = me.$enumeration.StorageType

      return [storageTypes.GDReferenceDocument, storageTypes.GDSubmitExercise].includes(me.storageType)
    },
    moreInfoObj () {
      const me = this
      let result = {}
      try {
        result = JSON.parse(me.moreInfo) || {}
      } catch (ex) {
        // parse moreInfo fail
      }
      return result
    },
    embedUrl () {
      const me = this

      if (me.isUseEmbedUrl) {
        const storageTypes = me.$enumeration.StorageType

        switch (me.storageType) {
          case storageTypes.GDReferenceDocument:
          case storageTypes.GDSubmitExercise:
            return `https://drive.google.com/file/d/${me.moreInfoObj.Id || me.moreInfoObj.id}/preview`
        }
      }
      return null
    },
    urlViewer () {
      if (this.isUseEmbedUrl) {
        return this.embedUrl
      }

      // 1 só lỗi nên cần mã hóa thành base64 rồi ms truyền đi
      const base64Url = btoa(unescape(encodeURIComponent(this.url)))
      // return `http://localhost:3000/web/viewer.html?file=${base64Url}`
      return `${window.__env.publicPath}src/pdfjs/web/viewer.html?file=${base64Url}`
    },
    fileName () {
      return this.$props.clientFileName?.replace(/\.[^/.]+$/, '')
    },
    styleVisibleImage () {
      if (this.$props.isViewerImage) {
        return 'visibility:hidden;'
      }
      return ''
    },
    // degreeChanged () {
    //   return (this.degreeInViewer - this.degreeDefault) || 0
    // },
    classNameContainerButtonSaveImage () {
      return `${this.containerId}__button-save-image`
    }
  },

  render: function (createElement) {
    const me = this
    const fileExtension = me.$props.fileExtension?.toLowerCase()
    let clsSwapPreview = 'previous-page'
    let showFileName = true
    if (me.imgId === '') {
      me.imgId = 'img_' + newUuid()
    }
    // videoMp4
    if (me.videoMp4 === '') {
      me.videoMp4 = 'videoMp4_' + newUuid()
    }
    let htmlContent = (
      <iframe
        key={me.fileId}
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
        frameborder="no"
        class={`iframe-item ${FileExtention.AudioAndVideo.includes(me.fileExtension) ? 'google-video-or-audio' : ''}`}
        thumbnail-link={me.moreInfoObj.thumbnailLink}
        content-type={me.moreInfoObj.mimeType}
        src={me.urlViewer}
      />
    )
    if (!me.isUseEmbedUrl) {
      switch (fileExtension) {
        case FileExtensionType.Png:
        case FileExtensionType.Jfjf:
        case FileExtensionType.Bmp:
        case FileExtensionType.Jpeg:
        case FileExtensionType.Jpg:
          htmlContent = (
            <img
              id={me.imgId}
              style={me.styleVisibleImage}
              class="image-item"
              src={me.url}
            />
          )
          break
        case FileExtensionType.Mp4:
        case FileExtensionType.M4a:
          htmlContent = (
            <video
              key={me.url}
              id={me.videoMp4}
              style="width: 100%; height: 100%; outline: none"
              onPlay={me.isShowPopupPreview ? me.onPlayVideo : ''}
              controls=""
              name="media"
              autoplay={me.isAutoPlay}
            >
              <source src={me.url} type="audio/mp4" />
            </video>
          )
          break
        case FileExtensionType.Mp3:
          htmlContent = (
            <video
              style="width: 100%; outline: none; height: 50px"
              key={me.url}
              controls=""
              name="media"
              autoplay={me.isAutoPlay}
            >
              <source src={me.url} type="audio/mp3" />
            </video>
          )
          break
        case FileExtensionType.Pdf:
        case FileExtensionType.Doc:
        case FileExtensionType.Docx:
        case FileExtensionType.Xls:
        case FileExtensionType.Xlsx:
        case FileExtensionType.Ppt:
        case FileExtensionType.Pptx:
        default:
          clsSwapPreview += ' swap-pdf'
          showFileName = false
      }
    }
    return (
      <div
        id={me.containerId}
        class="ms-preview-container"
        onClick={me.isShowPopupPreview ? me.openPopupPreview : ''}
      >
        {me.isShowPrevious ? (
          <img
            class={clsSwapPreview}
            onClick={me.backPage}
            src={me.previousPage}
          />
        ) : (
          ''
        )}
        {me.isShowFileName && showFileName ? (
          <div class="file-name-viewer text-neutral-500 title mt-4 ml-12">
            {me.fileName}
          </div>
        ) : (
          ''
        )}
        {htmlContent}
      </div>
    )
  },

  updated () {
    const me = this

    if (!this.$props.isViewerImage) {
      return
    }
    const el = document.getElementById(this.imgId)
    const lstViewContainer = document
      .getElementById(this.containerId)
      .querySelectorAll('.viewer-container')
    for (let i = 0; i < lstViewContainer.length; i++) {
      lstViewContainer[i].remove()
    }
    if (el) {
      delete el.viewer
      // eslint-disable-next-line no-undef
      const viewer = new Viewer(el, {
        inline: true,
        viewed () {
          viewer.zoomTo(1)
        },
        toolbar: {
          zoomIn: true,
          zoomOut: true,
          oneToOne: true,
          reset: true,
          // prev: false,
          // play: {
          //   show: false,
          //   size: 'large'
          // },
          // next: false,
          rotateLeft: true,
          rotateRight: true
          // flipHorizontal: false,
          // flipVertical: false
        },
        rotated: me.onRotatedImage
      })
      me.viewer = viewer
    }
  },

  methods: {
    // hàm show popup
    openPopupPreview () {
      const me = this

      me.showDetail(me.PreviewSetup, { data: me.$props })
      const propUperFirst = me.convertPropsToPascalcase(me.$props)

      const elMp4 = document.getElementById(me.videoMp4)
      if (elMp4) {
        me.isAllowPlaying = false
        elMp4.pause()
      }

      me.$emit('clickPreview', propUperFirst)
    },

    onPlayVideo (e) {
      const me = this
      if (!me.isAllowPlaying) {
        e.target.pause()
        me.isAllowPlaying = true
      }
    },

    async getOtherPopup (componentName) {
      let res = () => {}
      res = PreviewPopup
      return await res()
    },
    /**
     * Chuyển các props về dạng Pascal case
     */
    convertPropsToPascalcase () {
      const me = this
      const upperFirstVal = {}
      for (const key in me.$props) {
        upperFirstVal[upperFirst(key)] = me.$props[key]
      }
      return upperFirstVal
    },

    backPage () {
      const me = this
      me.$emit('previousPage', me)
    },

    /**
     * @author PVThang
     * @description xử lý sau khi xoay ảnh
     */
    onRotatedImage ({ detail }) {
      const me = this

      // if (detail) {
      //   me.degreeInViewer = detail.degree
      // }
      me.addButtonSaveImage()
    },

    /**
     * @author PVThang
     * @description Thêm button lưu ảnh
     */
    addButtonSaveImage () {
      const me = this
      let containerButtonSave = document.querySelector(`.${me.classNameContainerButtonSaveImage}`)

      if (!containerButtonSave) {
        const toolbar = document.querySelector(`#${me.containerId} .viewer-toolbar`)

        containerButtonSave = document.createElement('div')
        containerButtonSave.classList.add('button-save-container')
        containerButtonSave.classList.add(me.classNameContainerButtonSaveImage)

        const buttonSave = document.createElement('button')
        buttonSave.classList.add('ms-button')
        buttonSave.classList.add('el-button')
        buttonSave.classList.add('button-save')
        buttonSave.addEventListener('click', me.saveImageRotated)
        buttonSave.innerText = me.$t('Button.SaveImage')

        containerButtonSave.appendChild(buttonSave)
        toolbar?.appendChild(containerButtonSave)

        // const buttonSave = defineComponent({ extends: MsButton })
        // createApp(buttonSave).mount(containerButtonSave)

        // const buttonSave = { extends: MsButton }
        // containerButtonSave.append(buttonSave.$el)
      }
    },

    /**
     * @author PVThang
     * @description Xóa button lưu ảnh
     */
    removeButtonSave () {
      const me = this
      const containerButtonSave = document.querySelector(`.${me.classNameContainerButtonSaveImage}`)

      containerButtonSave?.remove()
    },

    /**
     * @author PVThang
     * @description Lưu ảnh đã xoay
     */
    async saveImageRotated () {
      const me = this
      const currentRotate = me.viewer.imageData.rotate
      const degreeChanged = (currentRotate - me.degreeSaved) || 0
      const minimunDegree = degreeChanged % 360 // 360 = 1 vòng

      if (minimunDegree) {
        const buttonSave = document.querySelector(`.${me.classNameContainerButtonSaveImage} .button-save`)
        buttonSave.disabled = true
        const payload = {
          FileID: me.fileId,
          FileExtension: me.fileExtension,
          StorageType: me.storageType,
          OwnerID: me.ownerId,
          Deg: minimunDegree,
          IsTemp: me.isTemp,
          CollectionName: me.collectionName,
          FieldName: me.fieldName
        }
        const res = await FileAPI.putAsync('image/rotate', payload)
        if (res?.Data) {
          me.degreeSaved = currentRotate
        }
        buttonSave.disabled = false
        me.showNotifyAfterSaveImage(res?.Data)
      } else {
        me.showNotifyAfterSaveImage(true)
      }
    },

    /**
     * @author PVThang
     * @description thông báo sau khi lưu ảnh
     */
    showNotifyAfterSaveImage (isSuccess) {
      const me = this

      if (isSuccess) {
        me.$notify.showSuccess({
          message: me.$t('NotifyMessage.SavedSuccess')
        })
      } else {
        me.$notify.showError({
          message: me.$t('NotifyMessage.HasErrorTryAgain')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~viewerjs/dist/viewer.min.css';
.ms-preview-container {
  position: relative;
  height: 100% !important;
  cursor: pointer;
  display: flex;
  align-items: center;

  .file-name-viewer {
    position: absolute;
    z-index: 1;
    top: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 20px;
  }

  .previous-page {
    position: absolute;
    z-index: 1;
    cursor: pointer;
    top: 20px;
    left: 20px;
    width: 16px;
    height: 16px;
  }
  .previous-page.swap-pdf {
    top: 20px;
    left: 20px;
  }
  :deep(.viewer-navbar) {
    display: none;
  }
  :deep(.viewer-button) {
    display: none;
  }
  :deep(.viewer-next) {
    display: none;
  }
  :deep(.viewer-prev) {
    display: none;
  }
  :deep(.viewer-play) {
    display: none;
  }
  :deep(.viewer-title) {
    display: none;
  }

  :deep(.button-save-container) {
    @apply absolute top-0 right-0 h-full w-28 flex justify-center items-center;

    .button-save {
      @apply h-10 w-full bg-accent-200 rounded text-primary mr-3;

      &:disabled {
        @apply bg-neutral-300 text-neutral-400;
      }
    }
  }
}
.ms-preview-container:hover {
  background-color: #ccc;
}
.image-item {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.iframe-item {
  width: 100%;
  height: 100%;
}

:deep(.viewer-backdrop) {
  background-color: $color-neutral-light-1;
}

:deep(.viewer-footer) {
  bottom: unset;

  .viewer-toolbar {
    background-color: $color-neutral-light-1;
    height: 56px;

    & > ul {
      padding: 16px 4px;

      & > li {
        border-radius: $border-radius-small;
        background-color: $color-neutral-light-4;
        margin: 0 4px;
        &:hover {
          background-color: $color-neutral-light-5;
        }
      }
    }
  }
}

:deep(.viewer-close:before, .viewer-flip-horizontal:before, .viewer-flip-vertical:before, .viewer-fullscreen-exit:before, .viewer-fullscreen:before, .viewer-next:before, .viewer-one-to-one:before, .viewer-play:before, .viewer-prev:before, .viewer-reset:before, .viewer-rotate-left:before, .viewer-rotate-right:before, .viewer-zoom-in:before, .viewer-zoom-out:before) {
  background-size: 560px;
  width: 28px;
  height: 28px;
}
</style>
